"use client"

import { MessageSquareHeart } from "lucide-react"
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem, useSidebar } from "@/components/ui/sidebar"
import { useFeedback } from "./feedback-provider"

/** Пункт «Обратная связь» внизу сайдбара: форма с текстом, скриншотами, записью экрана и файлами */
export function NavFeedback() {
  const feedback = useFeedback()
  const { isMobile, setOpenMobile } = useSidebar()
  if (!feedback) return null
  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <SidebarMenuButton
          tooltip="Сообщить об ошибке или предложить улучшение"
          className={`rounded-lg h-9 !font-normal cursor-pointer ${isMobile ? "px-3 py-2" : ""}`}
          onClick={() => {
            if (isMobile) setOpenMobile(false)
            feedback.openProduct()
          }}
          data-testid="feedback-button"
        >
          <MessageSquareHeart className="size-4" />
          <span className="!font-normal">Обратная связь</span>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
